/**
 * Constants Index
 * 모든 상수들을 한 곳에서 export
 */

// 앱에서 선택 가능한 언어 목록 (language.js, 날짜/시간 표기 등에서 사용)
export const LOCALE = [
    { code: 'ko', name: 'korean', locale: 'ko-KR', default: false },
    { code: 'ja', name: 'japanese', locale: 'ja-JP', default: false },
    { code: 'de', name: 'german', locale: 'de-DE', default: false },
    { code: 'en', name: 'english', locale: 'en-US', default: true },
    { code: 'zh-Hans', name: 'chinese_simplified', locale: 'zh-CN', default: false },
    { code: 'zh-Hant', name: 'chinese_traditional', locale: 'zh-TW', default: false },
];

/** LOCALE의 code 목록 — tblLanguage 행의 언어별 컬럼 순회 등에 사용 */
export const LOCALE_LANG_CODES = LOCALE.map(l => l.code);

/** LOCALE 중 default: true 인 언어 코드 (fallback용) */
export const DEFAULT_LOCALE_CODE = LOCALE.find(l => l.default)?.code || 'en';

/** LOCALE 중 default: true 인 전체 locale 문자열 (예: ko-KR, fallback용) */
export const DEFAULT_LOCALE = LOCALE.find(l => l.default)?.locale || 'en-US';

/** 국가 옵션  */
export const COUNTRY_OPTIONS = [
    { value: 'ko', label: 'south_korea' },
    { value: 'ja', label: 'japan' },
    { value: 'de', label: 'germany' },
    { value: 'zh-Hans', label: 'china_simplified' },
    { value: 'zh-Hant', label: 'china_traditional' },
    // { value: 'en', label: 'united_states' }
];

// Exercise Target Constants
export const EXERCISE_TARGETS = {
    // 걸음수 기준점 (100%)
    STEPS: 6000,

    // 활동시간 기준점 (100%) - 분 단위
    ACTIVITY_TIME: 90,

    // 칼로리 기준점 (100%) - kcal 단위
    CALORIES: 500,
};

export const CHALLENGE_HEARTBEAT = 120;

export const CHALLENGE_HEARTBEAT_MAX = 220;

export const ORGANIZATION_TYPES = [
    { value: 0, label: 'org_type_kindergarten', grades: ['age_3', 'age_4', 'age_5'], class: 'class_sun', classCount: 2 },
    { value: 1, label: 'org_type_elementary_school', grades: ['grade_1', 'grade_2', 'grade_3', 'grade_4', 'grade_5', 'grade_6'], class: 'class_1', classCount: 5 },
    { value: 2, label: 'org_type_middle_school', grades: ['grade_1', 'grade_2', 'grade_3'], class: 'class_1', classCount: 5 },
    { value: 3, label: 'org_type_high_school', grades: ['grade_1', 'grade_2', 'grade_3'], class: 'class_1', classCount: 5 },
    { value: 4, label: 'org_type_youth_facility', grades: ['grade_weekend'], class: 'class_default', classCount: 1 },
    { value: 5, label: 'org_type_welfare_facility', grades: ['grade_weekend'], class: 'class_default', classCount: 1 },
    { value: 6, label: 'org_type_other', grades: ['grade_weekend'], class: 'class_default', classCount: 1 },
];

export const REGIONS = [
    { country: 'ko', value: 'seoul', label: 'seoul_special_city', shortLabel: 'seoul' },
    { country: 'ko', value: 'busan', label: 'busan_metropolitan_city', shortLabel: 'busan' },
    { country: 'ko', value: 'daegu', label: 'daegu_metropolitan_city', shortLabel: 'daegu' },
    { country: 'ko', value: 'incheon', label: 'incheon_metropolitan_city', shortLabel: 'incheon' },
    { country: 'ko', value: 'gwangju', label: 'gwangju_metropolitan_city', shortLabel: 'gwangju' },
    { country: 'ko', value: 'daejeon', label: 'daejeon_metropolitan_city', shortLabel: 'daejeon' },
    { country: 'ko', value: 'ulsan', label: 'ulsan_metropolitan_city', shortLabel: 'ulsan' },
    { country: 'ko', value: 'sejong', label: 'sejong_special_self_governing_city', shortLabel: 'sejong' },
    { country: 'ko', value: 'gyeonggi', label: 'gyeonggi_province', shortLabel: 'gyeonggi' },
    { country: 'ko', value: 'gangwon', label: 'gangwon_province', shortLabel: 'gangwon' },
    { country: 'ko', value: 'chungbuk', label: 'chungcheongbuk_do', shortLabel: 'chungbuk' },
    { country: 'ko', value: 'chungnam', label: 'chungcheongnam_do', shortLabel: 'chungnam' },
    { country: 'ko', value: 'jeonbuk', label: 'jeollabuk_do', shortLabel: 'jeonbuk' },
    { country: 'ko', value: 'jeonnam', label: 'jeollanam_do', shortLabel: 'jeonnam' },
    { country: 'ko', value: 'gyeongbuk', label: 'gyeongsangbuk_do', shortLabel: 'gyeongbuk' },
    { country: 'ko', value: 'gyeongnam', label: 'gyeongsangnam_do', shortLabel: 'gyeongnam' },
    { country: 'ko', value: 'jeju', label: 'jeju_special_self_governing_province', shortLabel: 'jeju' },
    { country: 'ja', value: 'tokyo', label: 'tokyo_special_city', shortLabel: 'tokyo' },
    { country: 'ja', value: 'osaka', label: 'osaka_metropolitan_city', shortLabel: 'osaka' },
    { country: 'ja', value: 'nagoya', label: 'nagoya_metropolitan_city', shortLabel: 'nagoya' },
    { country: 'ja', value: 'sapporo', label: 'sapporo_special_city', shortLabel: 'sapporo' },
    { country: 'ja', value: 'fukuoka', label: 'fukuoka_metropolitan_city', shortLabel: 'fukuoka' },
    { country: 'ja', value: 'hiroshima', label: 'hiroshima_metropolitan_city', shortLabel: 'hiroshima' },
    { country: 'ja', value: 'kitakyushu', label: 'kitakyushu_metropolitan_city', shortLabel: 'kitakyushu' },
    { country: 'ja', value: 'sendai', label: 'sendai_metropolitan_city', shortLabel: 'sendai' },
    { country: 'de', value: 'berlin', label: 'berlin_special_city', shortLabel: 'berlin' },
    { country: 'de', value: 'hamburg', label: 'hamburg_metropolitan_city', shortLabel: 'hamburg' },
    { country: 'de', value: 'munich', label: 'munich_metropolitan_city', shortLabel: 'munich' },
    { country: 'de', value: 'frankfurt', label: 'frankfurt_metropolitan_city', shortLabel: 'frankfurt' },
    { country: 'de', value: 'stuttgart', label: 'stuttgart_metropolitan_city', shortLabel: 'stuttgart' },
    { country: 'de', value: 'dusseldorf', label: 'dusseldorf_metropolitan_city', shortLabel: 'dusseldorf' },
    { country: 'de', value: 'bonn', label: 'bonn_metropolitan_city', shortLabel: 'bonn' },
    { country: 'de', value: 'leipzig', label: 'leipzig_metropolitan_city', shortLabel: 'leipzig' },
    { country: 'de', value: 'dresden', label: 'dresden_metropolitan_city', shortLabel: 'dresden' },
    { country: 'de', value: 'hannover', label: 'hannover_metropolitan_city', shortLabel: 'hannover' },
    { country: 'de', value: 'esslingen', label: 'esslingen_metropolitan_city', shortLabel: 'esslingen' },
    { country: 'de', value: 'mannheim', label: 'mannheim_metropolitan_city', shortLabel: 'mannheim' },
    { country: 'de', value: 'karlsruhe', label: 'karlsruhe_metropolitan_city', shortLabel: 'karlsruhe' },
    { country: 'de', value: 'wuppertal', label: 'wuppertal_metropolitan_city', shortLabel: 'wuppertal' },
    { country: 'de', value: 'bielefeld', label: 'bielefeld_metropolitan_city', shortLabel: 'bielefeld' },
];

/** 국가 코드에 해당하는 지역 목록. 드롭다운/표시 시 option.label을 t(option.label)로 사용하면 사용자 로케일(앱 언어)에 맞게 표시됨. */
export const getRegionOptions = (country) => REGIONS.filter((r) => r.country === country);

export const USER_GENDERS = [
    { value: 0, label: 'male' },
    { value: 1, label: 'female' },
];

export const POINT_LOG_TYPES = [
    { value: -1, label: 'all_types' },
    { value: 0, label: 'earn' },
    { value: 1, label: 'expire' },
    { value: 2, label: 'use' },
];

export const CHAMPIONSHIP_TYPES = [
    { value: 0, label: 'ranking' },
    { value: 1, label: 'tournament' },
];

// 토너먼트 참가 인원/기간 옵션 (16강, 8강, 4강, 결승)
export const TOURNAMENT_PARTICIPANT_OPTIONS = [
    { value: 16, label: 'round_of_16' },
    { value: 8, label: 'quarter_finals' },
    { value: 4, label: 'semi_finals' },
    { value: 2, label: 'final' },
];

export const ORGANIZATION_RANKING_TYPES = [
    { value: 0, label: 'headcount_ranking' },
    { value: 1, label: 'cumulative_activity_ranking' },
];

/** 랭킹 타입 토글 옵션 (누적 / 이달) - label는 t(label)로 번역 */
/** 랭킹 타입 토글: value 0 = 누적, 1 = 이달 */
export const RANKING_TYPE_TOGGLE_OPTIONS = [
    { value: 0, label: 'cumulative' },
    { value: 1, label: 'this_month' },
];

/** API 목록/배치 조회 시 기본 페이지 크기 (백엔드 기본 limit 100과 동일) */
export const API_PAGE_SIZE = 100;

export const CONTENT_TYPES = [
    { value: 0, label: 'physical_training', desc: 'physical_training' },
    { value: 1, label: 'brain_training', desc: 'brain_training' },
    { value: 2, label: 'health_game', desc: 'health_game' },
];

export const ORGANIZATION_STATE = [
    { value: 0, label: 'state_normal', desc: 'state_normal' },
    { value: 1, label: 'withdrawn', desc: 'withdrawn' },
    { value: 2, label: 'pending_approval', desc: 'pending_approval' },
    { value: 3, label: 're_approval_pending', desc: 're_approval_pending' },
    { value: 4, label: 'rejected', desc: 'rejected' },
    { value: 5, label: 'delete', desc: 'delete' },
];

export const DIDIM_HW_FILTER_OPTIONS = [
    { value: 'unregistered', label: 'unregistered_didim_h_w' },
    { value: 'all', label: 'all_didim_h_w' },
    { value: 'search', label: 'search_by_didim_name' },
];

export const NOTICE_TYPES = [
    { value: 0, label: 'notice' },
    { value: 1, label: 'push_notification' },
];

export const EVENT_TYPES = [
    { value: 0, label: 'lottery', desc: 'lottery' },
    { value: 1, label: 'organization_ranking', desc: 'organization_ranking' },
    { value: 2, label: 'general', desc: 'general' },
];

// 푸시 알림 설정 옵션
export const PUSH_OPTIONS = [
    { key: 'stepPush', label: 'step_count_info', defaultValue: true },
    { key: 'levelupPush', label: 'level_up_info', defaultValue: true },
    { key: 'championPush', label: 'championship_info', defaultValue: true },
    { key: 'rewardPush', label: 'reward_earned_info', defaultValue: true },
    { key: 'noticePush', label: 'notice_and_event', defaultValue: true },
];